import React, {useState} from 'react';

export default function BioExpand(props) {
    const { teamMember, rightJustify } = props;
    const [expanded, setExpanded] = useState(false);

    let body;
    if (expanded) {
        body = (
            <div className="body d-flex flex-column">
                <div className="body-text p-2">
                    {teamMember.bio_paragraphs.map((paragraph) => (
                        <p dangerouslySetInnerHTML={{__html: paragraph}} />
                    ))}
                </div>
                <button
                    className="align-self-center btn btn-outline-primary"
                    type="button"
                    onClick={() => setExpanded(!expanded)}>
                    Show less
                </button>
            </div>
        );
    } else {
        body = (
            <div className="body preview">
                <button
                    className="btn overlay"
                    type="button"
                    onClick={() => setExpanded(!expanded)}
                />
                <div className="body-text">
                    <button
                        className="btn btn-light"
                        type="button"
                        onClick={() => setExpanded(!expanded)}>
                        View Full Bio
                    </button>
                    <p dangerouslySetInnerHTML={{__html: teamMember.bio_paragraphs[0]}} />
                </div>
            </div>
        )
    }

    return (
        <div className="card bio-card expand mb-4 px-0 pb-3">
            <div className={`align-items-center row no-gutters justify-content-between ${rightJustify ? 'flex-row-reverse ' : ''}p-2`}>
                <div className={`col-7 d-flex flex-column justify-content-between mt-1 ${rightJustify ? 'pl-2' : ''}`}>
                    <div>
                        <h5>{teamMember.name}</h5>
                        <h6 dangerouslySetInnerHTML={{__html: teamMember.job_title}}/>
                    </div>
                </div>
                <div className="col-5 d-flex flex-column align-items-center">
                    <img alt={`Image of ${teamMember.name}`} className="img" src={teamMember.image_source}/>
                </div>
            </div>
            { body }
        </div>
    );
}

    import { render } from 'react-dom'                                    
    if (window.reactComponents === undefined) {                           
      window.reactComponents = {}                                         
    }                                                                     
    window.reactComponents.undefined = (function() {                   
    let _args = {}                                                        
                                                                          
    return {                                                              
      init: function (Args) {                                             
        _args = Args                                                      
      },                                                                  
      render: function () {                                               
        const  { id, ...props } = JSON.parse(_args)                       
        render(<undefined {...props}/>, document.getElementById(id))   
      }                                                                   
    }                                                                     
  }())